import { VpButton, VpProgressBar } from '@vtmn-play/react'
import { HTMLAttributes, useMemo } from 'react'
import { FamilyCardHeader } from '@/src/components/global/family-card/family-card-header/FamilyCardHeader'
import { CardShell } from '@/src/components/global/card-shell/CardShell'
import CardScore from '@/src/components/global/card-score/CardScore'
import { FamilyDto } from '@/infra/api/generated/model'

type buttonProps = {
  label: string
  onClick: () => void
}

type FamilyCardProps = HTMLAttributes<HTMLDivElement> & {
  family: FamilyDto
  completionPercentage?: number
  score?: number
  date: string
  buttonProps?: buttonProps
}

const FamilyCard = ({
  family,
  completionPercentage,
  score,
  date,
  buttonProps,
  ...props
}: FamilyCardProps) => {
  const formattedDate = useMemo(() => new Date(date).toLocaleDateString(), [date])
  return (
    <CardShell {...props}>
      <div className="flex flex-col gap-2">
        <FamilyCardHeader family={family} />
        <div className="flex justify-between items-center">
          <span className="text-neutral-500 text-sm">{formattedDate}</span>
          <CardScore score={score} />
        </div>
      </div>
      {typeof completionPercentage === 'number' && (
        <VpProgressBar size="small" value={completionPercentage} aria-label="progress-bar" />
      )}
      {buttonProps && (
        <VpButton
          className="w-full"
          shape="squared"
          variant="secondary"
          onClick={() => buttonProps?.onClick()}
        >
          {buttonProps.label}
        </VpButton>
      )}
    </CardShell>
  )
}

export default FamilyCard
